var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


module.exports = Backbone.View.extend({

	events: {
		'click span.tag': 'handleClick',
		'click span.more': 'handleMore',
	},

	initialize: function() {
		this.listenTo(this.model, "change:tags", this.render);
		this.listenTo(this.model, "change:selectedTags", this.render);
		this.listenTo(this.model, "change:tagsCount", this.render);
	},

	render: function() {
		var selectedTags = this.model.get("selectedTags");
		this.el.innerHTML = TemplateCache.render('SidebarTemplate', {
			groups: this.model.tagGroups,
			isSelected: function(tag_id) {
				tag_id = parseInt(tag_id, 10);
				return selectedTags.indexOf(tag_id) !== -1;
			},
		});

		/* Fix the layout (list + maps) */
		$('.result-tabs').css('min-height', $('#engine-sidebar').outerHeight());
	},

	handleClick: function(e) {
		e.preventDefault();
		var link = $(e.currentTarget);
		if ( link.hasClass('disabled') ) return;
		this.model.toggleTag(link.data('id'));
	},

	handleMore: function(e) {
		e.preventDefault();
		var link = $(e.currentTarget);
		var group = link.data('group');

		$('.tag_group_'+group+' .hidden').removeClass('hidden');
		link.hide();
	},

});



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/browser/views/SidebarView.js